var _rect, _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0445 49.7723H31.4456C31.2191 49.7723 31.002 49.6803 30.8419 49.5166C30.6817 49.353 30.5918 49.131 30.5918 48.8995V31.445C30.5918 31.2135 30.6817 30.9915 30.8419 30.8279C31.002 30.6642 31.2191 30.5723 31.4456 30.5723H48.5207C48.7471 30.5723 48.9642 30.6642 49.1243 30.8279C49.2845 30.9915 49.3744 31.2135 49.3744 31.445V43.3017C49.3744 43.4163 49.3523 43.5298 49.3094 43.6357C49.2665 43.7415 49.2036 43.8378 49.1243 43.9188L43.6482 49.5166C43.5689 49.5977 43.4748 49.662 43.3712 49.7058C43.2676 49.7497 43.1566 49.7723 43.0445 49.7723V49.7723Z",
    stroke: "currentColor",
    strokeWidth: 1.56522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8697 43.6523H43.6523V48.8697",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8697 43.6523H43.6523V48.8697",
    stroke: "currentColor",
    strokeWidth: 1.56522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlaceholder);
export default __webpack_public_path__ + "static/media/file-placeholder.3f6d4da9cca388a0bebbc5950447a576.svg";
export { ForwardRef as ReactComponent };